/* src/app/google-translate/google-translate.component.css */
#google_translate_element {
  height: 26px !important;
  overflow: hidden !important;
}
/*# sourceMappingURL=google-translate.component-FTAIZT3V.css.map */
